query ListYouTubeTelemetry($days: Int) {
  telemetry: StreamToolsListYouTubeTelemetry(days: $days) {
    budget
    remainingToday
    days {
      date
      units
      calls
      demoUnits
      demoCalls
      sessionsStarted
      refusedSessionStarts
      refusedNotLive
      refusedAlreadyRunning
      peakUnitsPerMinute
    }
  }
}
